import { render, staticRenderFns } from "./CustomPOIImageTextList.vue?vue&type=template&id=573ef0e3&scoped=true&"
import script from "./CustomPOIImageTextList.vue?vue&type=script&lang=js&"
export * from "./CustomPOIImageTextList.vue?vue&type=script&lang=js&"
import style0 from "./CustomPOIImageTextList.vue?vue&type=style&index=0&id=573ef0e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573ef0e3",
  null
  
)

export default component.exports